import { isEmptyString } from 'utils/stringHelpers';
import { FieldType } from '../../../types';

export const doesEventFieldMatchSearch = (name: string, fieldType: FieldType, search: string) =>
  isEmptyString(search) ||
  name.toLowerCase().includes(search.toLowerCase()) ||
  fieldType.toLowerCase().includes(search.toLowerCase());
